import { ofType } from 'redux-observable';
import {
  catchError,
  delay,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { UPSERT_SPESA } from '../../data.const';
import {
  retrieveSpesaListAction,
  setCurrentSpesaAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';
import { rootConfig } from '../../../../../config/root-config';

const upsertSpesaEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(UPSERT_SPESA),
    tap((p) => console.log(`[epic ${UPSERT_SPESA}]`, p)),
    map(({ payload }: any) => {
      const { createdAt, updatedAt, ...rest } = payload?.body;
      if (rest.id === 'crea') {
        delete rest.id;
      }
      return { info: payload?.info, body: rest };
    }),
    tap((p) => console.log(`[epic ${UPSERT_SPESA}]`, p)),
    withLatestFrom(state$),
    switchMap(([{ body, info }, state]) => {
      return concat(
        of(setLoaders({ incaricoLoader: true, page: true })),
        defer(() =>
          from(
            request({
              path: `spesa`,
              method: httpMethods.POST,
              body,
            })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error(p.message);
              }
              return p?.result;
            }),
            switchMap((data) =>
              concat(
                of(setCurrentSpesaAction(data)),
                of(null).pipe(
                  delay(500),
                  switchMap(() =>
                    concat(
                      of(
                        setPopupInfo({
                          opened: true,
                          message: 'Operazione completata con successo',
                          timer: 3000,
                        })
                      ),
                      of(
                        retrieveSpesaListAction({
                          pageSize: rootConfig.pageSize,
                          page: 1,
                          incaricoId: info?.incaricoId,
                          order: [['createdAt', 'desc']],
                          filters: {
                            or: [
                              {
                                field: '$Incarico.id$',
                                value: info?.incaricoId,
                              },
                            ],
                          },
                        })
                      ),
                      of(null).pipe(
                        tap(() => {
                          info?.action && info?.action();
                          info?.refreshParent &&
                            info?.refreshParent((p) => p + 1);
                        }),
                        switchMap(() => EMPTY)
                      )
                    )
                  )
                )
              )
            ),
            catchError((err) => {
              console.error(`[epic ${UPSERT_SPESA}] error`, err);
              return of(
                setPopupInfo({
                  opened: true,
                  message: 'Operazione non riuscita',
                  type: 'BAD',
                  timer: 3000,
                })
              );
            })
          )
        ),
        of(setLoaders({ incaricoLoader: false, page: false }))
      );
    })
  );

export default upsertSpesaEpic;
